<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<template>
  <v-list class="pt-0">
    <div
      v-for="item in items"
      :key="item.subheading">
      <v-subheader>
        {{ item.subheading }}
      </v-subheader>
      <v-list-tile
        v-for="page in item.pages"
        :key="page.title"
        :href="page.href || null"
        :to="page.to || null">
        <v-list-tile-action>
          <v-icon>{{ page.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ page.title }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action v-if="page.badge">
          <v-chip
            small
            outline
            disabled
            :color="page.badge.backgroundColor"
            :text-color="page.badge.textColor">
            {{ page.badge.text }}
          </v-chip>
        </v-list-tile-action>
      </v-list-tile>
    </div>
  </v-list>
</template>



// WEBPACK FOOTER //
// src/components/TwNavigationList.vue